import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fromAuth } from '../store';
import { Account } from '../models';
import { useGetG2Accounts, useGetG3Accounts } from '../hook/useGetAccounts';

interface AccountProps {
  loading: boolean;
  accounts: Account[];
}

const defaultProps: AccountProps = {
  loading: true,
  accounts: [],
};

const AccountContext = createContext<AccountProps>(defaultProps);

export const AccountProvider = (
  { children }: { children: React.ReactNode },
) => {
  const [loading, setLoading] = useState(true);
  const user = useSelector(fromAuth.selectUser);
  const { g2Accounts, g2Loading } = useGetG2Accounts(user);
  const { g3Accounts, g3Loading } = useGetG3Accounts(user);
  const [accounts, setAccounts] = useState<Account[]>([]);
  const accountMap: Map<number, Account> = new Map();

  useEffect(() => {
    if (!g2Loading && !g3Loading) {
      g2Accounts.forEach(acc => {
        if (!accountMap.has(acc.id)) {
          accountMap.set(acc.id, acc);
        }
      });
      g3Accounts.forEach(acc => {
        if (!accountMap.has(acc.id)) {
          accountMap.set(acc.id, acc);
        }
      });
      setAccounts(Array.from(accountMap.values()));
      setLoading(false);
    }
  }, [g3Accounts, g2Accounts]);

  return (
    <AccountContext.Provider value={{ loading, accounts }}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => useContext(AccountContext);
